import axios from 'axios'
import qs from 'qs'

export const leapsEnergyService = ({
  getLeapsEnergyList (token) {
    return axios.get('/api/leaps/Energy', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createLeapsEnergy (token, leapsEnergyObj) {
    var stringifiedObj = qs.stringify(leapsEnergyObj)
    return axios.post('/api/leaps/Energy', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateLeapsEnergy (token, leapsEnergyObj) {
    var stringifiedObj = qs.stringify(leapsEnergyObj)
    return axios.put('/api/leaps/Energy', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteLeapsEnergy (token, energryId) {
    return axios.delete('/api/leaps/Energy?energyid=' + energryId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/leaps-energy-service.js